import {Cart} from '@modules/cart/Cart';
import {isNumber} from '@util/NumberUtil';

export async function calculateMaxInputQuantityForProduct ( {product, inCartQuantity} ) {
    let maxQuantity = product?.maxQuantity;
    let maxQuantityExceeded = false;
    let maxInputQuantity = 99;

    // if not given an inCartQuantity then fetch it
    if ( !isNumber( inCartQuantity ) ) {
        let cartLine = upi.conf.isEcommerceSite ? await Cart.getLineBySku( product?.sku ) : null;
        inCartQuantity = parseInt( cartLine?.quantity ) || 0;
    }
    if ( isNumber( maxQuantity ) ) {
        maxInputQuantity = Math.max( 0, maxQuantity - inCartQuantity );
        maxQuantityExceeded = (inCartQuantity >= maxQuantity) || maxQuantity === 0;
    }

    return {
        maxQuantity,
        maxInputQuantity,
        maxQuantityExceeded,
        inCartQuantity
    };
}
